import React from 'react';
import { useDispatch} from 'react-redux';
import { reset } from 'redux-form';
import * as actions from '../../../core/actions/actions';
import UserProfile from './UserProfile';
interface IProps {
  id:string;
  userName:string;
  userType:string;
  modalClosed: () => void;
}
const UserProfilePopUp : React.FC<IProps> = (props) => {
  
  const dispatch = useDispatch();
  
  const onModalClosed = () => {
    dispatch(actions.resetChangePasswordState());
    dispatch(reset('ChangePasswordForm')); 
    props.modalClosed();
  }
 
  return (
    <React.Fragment>
      <UserProfile
         id={props.id}
         userName={props.userName}
         userType={props.userType}
         onModalClosed={onModalClosed}
      />
    </React.Fragment>
  );
};

export default UserProfilePopUp;
